import { onMounted } from "vue";
//@ts-ignore
import { injectScriptTag } from "@utils/DOMUtils";
//@ts-ignore
import { observeOnce } from "@utils/ObserverUtils";
export var useTrustpilotWidget = () => {
  onMounted(() => {
    observeOnce(".trustpilot-widget", () => {
      //Trustpilot script
      injectScriptTag({
        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      });
    });
  });
};